import React from 'react'
import { accessToken } from '@/helpers/props'
import Head from 'next/head'
import { NextPageContext } from 'next'
import Login from '@/components/login/Login'

const LoginPage = () => {
  return (
    <>
      <Head>
        <title>ورود | ثبت نام</title>
        <link rel="canonical" href={`https://www.shab.ir/login`} />
      </Head>
      <Login />
    </>
  )
}

export const getServerSideProps = async (ctx: NextPageContext) => {
  if (accessToken(ctx)) {
    const { req, res, query } = ctx
    if (typeof window === 'undefined') {
      const protocol = req?.headers['x-forwarded-proto'] || 'http'
      const host = req?.headers['host']
      const origin = `${protocol}://${host}`
      const nextUrl = query?.next_url as string
      if (nextUrl) {
        ;(res as any).redirect(
          `${origin}${nextUrl?.startsWith('/') ? nextUrl : '/' + nextUrl}`,
        )
      } else {
        ;(res as any).redirect(origin)
      }
    } else {
      ;(res as any).redirect('/')
    }
  }
  return { props: {} }
}

export default LoginPage
